import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { findIndex } from 'lodash';

export const getActiveHintMessage = (state = Services.store.state) => state?.hintMessages?.activeHintMessage;

export const areHintMessagesDisabled = (state = Services.store.state) =>
  state?.hintMessages?.disableHintMessages;

export const hasHintMessage = (hintMessages, message) => {
  return findIndex(hintMessages, (msg) => msg === message) !== -1;
};
